import vueQr from './vue-qr';

vueQr.install = Vue => Vue.component(vueQr.name, vueQr);

export default vueQr;



// WEBPACK FOOTER //
// ./src/packages/index.js